const store = require('../store/index')

export default (to, from, next) => {
  if ((store.default.getters.user !== null && store.default.getters.user !== undefined)) {
      next();
  } else {
    next('/login');
  }
};
